import ExcelGrid from "components/Custom/ExcelGrid";
import React, { useEffect, useRef, useState } from "react";

import UiDialog from "components/Custom/UiDialog";
import { IconButton, Tooltip } from "@mui/material";

import { DEFAULTS } from "common/config";
import { LABELS, TITLES } from "common/lables";
import { COLORS } from "common/colors";

import { GEO_APIs } from "apihandlers/geography";

import { Edit as IconEdit } from "@mui/icons-material";
import TxtRow from "components/Custom/TxtRow";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";
import { log } from "console";

const gridData = require("./gridJson.json");

const GridExcel = (props: any) => {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<any>(null);
  // {
  //   id: "1",
  //   slNo: "1",
  //   buisnessType: "Jnanesh",
  //   price: "10",
  //   total: "",
  //   area: "Udupi",
  // },
  // {
  //   id: "2",
  //   slNo: "2",
  //   buisnessType: "Keerthan",
  //   price: "10",
  //   total: "",
  //   area: "Udupi",
  // },
  // {
  //   id: "3",
  //   slNo: "3",
  //   buisnessType: "Jelena",
  //   price: "11",
  //   total: "",
  //   area: "Udupi",
  // },
  // {
  //   id: "4",
  //   slNo: "4",
  //   buisnessType: "Abhi",
  //   price: "11",
  //   total: "",
  //   area: "Honnavara",
  // },

  const [selectedRow, setSelectedRow] = useState<any>({});
  const [manageDialog, setManageDialog] = useState(false);
  const [area, setArea] = useState([]);

  const areaRef = useRef(null);
  const gridRef: any = useRef(null);
  const childGridRef: any = useRef(null);

  const calculateAmount = (row: any) => {
    let price = row["price"];
    let quantity = row["quantity"];
    let total = 0;
    total = price * quantity;
    row["total"] = total;
    console.log("Price", total);
    return total;
  };
  const Columns = [
    {
      key: "",
      selectColumn: true,
    },
    {
      key: "expanded",
    },
    {
      key: "slNo",
      name: "Sl No",
      width: "10%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: false,
      searchable: false,
    },
    {
      key: "name",
      name: "Name",
      width: "30%",
      type: "text",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      searchable: true,
      isDisabled: (row: any) => {
        return row.name == "Abhishek";
      },
    },
    {
      key: "address",
      name: "Address",
      width: "20%",
      type: "text",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      searchable: false,
      // formula: calculateAmount,
      // renderSum: true,
      // renderSumPrefix: "karthik total:",
    },
    {
      key: "class",
      name: "Class",
      width: "20%",
      type: "text",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      searchable: false,
      // formula: calculateAmount,
      // renderSum: true,
      // renderSumPrefix: "karthik total:",
    },
    // {
    //   key: "total",
    //   name: "Amount",
    //   width: "20%",
    //   type: "number",
    //   align: "center",
    //   headerAlign: "center",
    //   editable: false,
    //   sortable: false,
    //   searchable: false,
    //   formula: calculateAmount,
    //   renderSum: true,
    //   renderSumPrefix: "karthik total:",
    // },

    // {
    //   key: "area",
    //   name: "Area",
    //   width: "25%",
    //   searchable: true,
    //   editable: true,
    //   type: "dropdown",
    //   list: [
    //     {
    //       id: "udupi",
    //       label: "udupi",
    //     },
    //     {
    //       id: "honnavar",
    //       label: "honnavar",
    //     },
    //   ],
    //   filters: [
    //     {
    //       id: "udupi",
    //       label: "udupi",
    //     },
    //     {
    //       id: "honnavar",
    //       label: "honnavar",
    //     },
    //   ],
    //   align: "center",
    //   headerAlign: "center",
    //   sortable: true,
    // },

    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "20%",
      renderCell: (params: any) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];
  const gridColumn = [
    {
      key: "",
      selectColumn: true,
    },
    {
      key: "slNo",
      name: "Sl No",
      width: "10%",
      type: "number",
    },
    {
      key: "subject",
      name: "Subject",
      width: "40%",
      type: "text",
    },
    {
      key: "marks",
      name: "Marks",
      width: "40%",
      type: "number",
    },
  ];

  useEffect(() => {
    getRows();
  }, []);
  //
  // const getAreas = () => {
  //   const args = {
  //     pageNo: 1,
  //     pageLength: DEFAULTS.PAGE_LENGTH,
  //     activeStatus: true,
  //     minResponse: true,
  //   };
  //   GEO_APIs.getAreas(args).then((res: any) => {
  //     const response: any = res.response;
  //     const { status } = res;
  //     if (status === 200) {
  //       let list = response.records;
  //       list = response.records.map((r) => {
  //         return {
  //           id: r.id,
  //           label: r.areaName,
  //         };
  //       });
  //       setArea(list);
  //       getRows();
  //     }
  //   });
  // };

  const getRows = () => {
    const res = gridData;
    let list = res.response.records;
    console.log("response", list);
    for (let i = 0; i < list.length; i++) {
      list[i]["slNo"] = i + 1;
      list[i]["_type"] = "maingrid";
      list[i]["_expanded"] = false;
      let subList = list[i].perfomance;
      for (let j = 0; j < subList.length; j++) {
        subList[j]["slNo"] = j + 1;
      }
      list[i]["_subGrid"] = () => subGrid(subList);
    }
    setRows(list);
    setLoading(true);

    // const args = {
    //   pageNo: 1,
    //   pageLength: DEFAULTS.PAGE_LENGTH,
    // };
    // GEO_APIs.getStates(args).then((res: any) => {
    //   const response: any = res.response;
    //   const { status } = res;
    //   if (status === 200) {
    //     let list = response.records;
    //     for (let i = 0; i < list.length; i++) {
    //       list[i]["slNo"] = i + 1;
    //       if (list[i]["activeStatus"]) {
    //         list[i]["activeStatus"] = "Yes";
    //       } else {
    //         list[i]["activeStatus"] = "No";
    //       }
    //       list;
    //     }
    //     // setRows(list);
    //   }
    // });
  };

  const subGrid = (subRows = []) => {
    console.log("subRows", subRows);
    return (
      <>
        {subRows && (
          <ExcelGrid
            id={"jii"}
            childRef={childGridRef}
            cols={gridColumn}
            rows={subRows}
            isSubGrid={subRows.length != 0 ? true : true}
            // noTotalRows={true}
            // newRowOption={false}
            // onAdd={onAdd}
            // getDefaultNewRow={getDefaultNewRow}
          />
        )}
      </>
    );
  };
  console.log("rows", rows);

  const onAdd = () => {
    setManageDialog(true);
  };
  const Reload = () => {
    setRows(null);
    getRows();
  };

  const onSave = () => {
    const buisnessType = (
      document.getElementById("businessType") as HTMLInputElement
    ).value.trim();
    const area = areaRef.current.selectedValue.id;
    let ele = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = ele ? ele.value : "";

    const args = {
      buisnessType,
      area,
      activeStatus,
    };
    console.log("args", args);
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
  };
  const onEdit = () => {
    let editArgs = gridRef.getRowData();
    console.log("editArgs", editArgs);
  };

  console.log("selected Row", selectedRow);

  //   return (
  //     <div style={{ padding: "1rem" }}>
  //       <div className="pageInfo">
  //         <ul className="breadcrumbs">
  //           <li>{"HOME"}</li>
  //           <li className="dim">{" / "}</li>
  //           <li>{"kARTHIK"} </li>
  //           <li className="dim">{" / "}</li>
  //           <li className="active">{"Page1"}</li>
  //         </ul>
  //         <h4>{"Page1"}</h4>
  //         <p>{"BUSINESS_CATEGORY"}</p>
  //       </div>

  //       <ExcelGrid
  //         id={"businessCategory"}
  //         childRef={gridRef}
  //         cols={Columns}
  //         height={window.innerHeight * 0.8}
  //         rows={rows}
  //         exportOption={true}
  //         newRowOption={false}
  //         exportName={"BUSINESS_CATEGORY"}
  //         onReload={"reloadGrid"}
  //         onAdd={onAdd}
  //         // hideUnhide={true}
  //         // freezeOption={true}
  //         leftSideBtns={
  //           <>
  //             <Btn
  //               text={LABELS.CANCEL}
  //               bgColor={COLORS.RELOAD_EXPORT}
  //               color={COLORS.RELOAD_EXPORT_TEXT}
  //               onClick={() => {
  //                 setManageDialog(false);
  //               }}
  //             />
  //             <Btn
  //               text={LABELS.SAVE}
  //               onClick={"manageBusinessCategory"}
  //               bgColor={COLORS.SAVE_GREEN}
  //             />
  //           </>
  //         }
  //       />
  //       <Btn text={LABELS.SAVE} onClick={onEdit} bgColor={COLORS.SAVE_GREEN} />

  //       {manageDialog && (
  //         <UiDialog
  //           title={
  //             selectedRow.id
  //               ? "Edit " + "PAGE1" + ": " + selectedRow.buisnessType
  //               : "Add " + "PAGE1"
  //           }
  //           open={true}
  //           size={"sm"}
  //           onClose={() => setManageDialog(false)}
  //         >
  //           <div className="formGroup required">
  //             <TxtRow
  //               id={"businessType"}
  //               type={"text"}
  //               label={"BUSINESS_TYPE"}
  //               required={true}
  //               defaultValue={""}
  //             />
  //           </div>
  //           <div className="formGroup ">
  //             <label>{"Area"}</label>
  //             <AutoComplete childRef={areaRef} list={area} />
  //           </div>
  //           <div className="formGroup ">
  //             <label>{"ACTIVE_STATUS"}</label>
  //             <RadioBtn
  //               list={[
  //                 {
  //                   id: "true",
  //                   value: "true",
  //                   label: "ACTIVE",
  //                   checked: selectedRow.id
  //                     ? selectedRow.activeStatus === true
  //                     : true,
  //                   disabled: false,
  //                 },
  //                 {
  //                   id: "false",
  //                   value: "false",
  //                   label: " INACTIVE",
  //                   checked: selectedRow.id
  //                     ? selectedRow.activeStatus === false
  //                     : false,
  //                   disabled: false,
  //                 },
  //               ]}
  //               row={true}
  //               name={"activeStatus"}
  //             />
  //           </div>

  const getDefaultNewRow = () => {
    var Length;

    rows.map((i, index) => {
      Length = index + 1;
    });
    Length++;

    const newRow: any = {
      slNo: gridRef.getRowData().length,
      buisnessType: "",
      price: "",
      quantity: "",
      total: "",
      area: "",
    };
    console.log("newRow", newRow);
    return newRow;
  };

  return (
    <div style={{ padding: "1rem" }}>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li>{"HOME"}</li>
          <li className="dim">{" / "}</li>
          <li>{"kARTHIK"} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{"Page1"}</li>
        </ul>
        <h4>{"Page1"}</h4>
        <p>{"BUSINESS_CATEGORY"}</p>
      </div>
      {loading && rows && (
        <ExcelGrid
          id={"businessCategory"}
          childRef={gridRef}
          cols={Columns}
          height={window.innerHeight * 0.8}
          rows={rows}
          exportOption={true}
          newRowOption={true}
          exportName={"BUSINESS_CATEGORY"}
          onReload={Reload}
          onAdd={onAdd}
          hideUnhide={true}
          // freezeOption={true}
          getDefaultNewRow={getDefaultNewRow}

          // leftSideBtns={
          //   <>
          //     <Btn
          //       text={LABELS.CANCEL}
          //       bgColor={COLORS.RELOAD_EXPORT}
          //       color={COLORS.RELOAD_EXPORT_TEXT}
          //       onClick={() => {
          //         setManageDialog(false);
          //       }}
          //     />
          //     <Btn
          //       text={LABELS.SAVE}
          //       onClick={"manageBusinessCategory"}
          //       bgColor={COLORS.SAVE_GREEN}
          //     />
          //   </>
          // }
        />
      )}
      <Btn text={LABELS.SAVE} onClick={onEdit} bgColor={COLORS.SAVE_GREEN} />

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + "PAGE1" + ": " + selectedRow.buisnessType
              : "Add " + "PAGE1"
          }
          open={true}
          size={"sm"}
          onClose={() => setManageDialog(false)}
        >
          <div className="formGroup required">
            <TxtRow
              id={"businessType"}
              type={"text"}
              label={"BUSINESS_TYPE"}
              required={true}
              defaultValue={""}
            />
          </div>
          <div className="formGroup ">
            <label>{"Area"}</label>
            <AutoComplete childRef={areaRef} list={area} />
          </div>
          <div className="formGroup ">
            <label>{"ACTIVE_STATUS"}</label>
            <RadioBtn
              list={[
                {
                  id: "true",
                  value: "true",
                  label: "ACTIVE",
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === true
                    : true,
                  disabled: false,
                },
                {
                  id: "false",
                  value: "false",
                  label: " INACTIVE",
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"activeStatus"}
            />
          </div>

          <div className="formGroup submitBtnWrapper">
            <div className="flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                }}
              />
              <Btn
                text={LABELS.SAVE}
                bgColor={COLORS.SAVE_GREEN}
                onClick={onSave}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </div>
  );
};

export default GridExcel;
